export const NumericalDisplayModes = {
    AUTO: "auto",
    BAR: "bar",
    HEATMAP: "heatmap",
};

export const AnnotationDisplayModes = {
    FULL: "full",
    DENSITY: "density",
};

export enum InteractionDisplayMode {
    HEATMAP = "heatmap",
    ARC = "arc",
    FLATARC = "flatarc",
    SQUARE = "square",
}

export enum DynamicInteractionDisplayMode {
    HEATMAP = "heatmap",
    ARC = "arc",
}

export const GenomeAlignDisplayModes = {
    ROUGH: "rough",
    FINE: "fine",
};

export const BigWigZoomLevels = {
    AUTO: "auto",
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
};
